/**
 * The app runs under a basePath (see next.config.mjs). Next.js prefixes it for
 * <Link>, router.push and redirects, but not for fetch(), <a href>, next/image
 * src or URLs built by hand. Wrap those paths with withBase().
 */
export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH ?? ''

export function withBase(path: string): string {
  if (!path.startsWith('/')) return path
  return `${BASE_PATH}${path}`
}
